import {
	AfterContentChecked,
	ContentChild,
	Directive,
	effect,
	input,
} from '@angular/core';
import { Subject } from 'rxjs';
import { PaginationTableColumnDisplayDirective } from './pagination-table-column-display.directive';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: 'ae-pgt-row-actions-column',
})
export class PaginationTableRowActionsColumnDirective<
	T,
> implements AfterContentChecked {
	readonly disabled = input(false);

	readonly size = input(3);

	@ContentChild(PaginationTableColumnDisplayDirective)
	public displayTemplate: PaginationTableColumnDisplayDirective<T>;

	private onChange = new Subject<void>();
	public onChange$ = this.onChange.asObservable();

	constructor() {
		effect(() => {
			const sizeVal = this.size();
			this.disabled();
			if (!(sizeVal >= 1 && sizeVal <= 4)) {
				console.error(
					`PaginationTableRowActionsColumnDirective size must be between 1-4, is currently set to ${sizeVal}`,
				);
			}
			this.onChange.next();
		});
	}

	ngAfterContentChecked(): void {
		if (this.displayTemplate == null) {
			throw Error(
				'ae-pgt-row-actions-column is missing required child ae-pgt-column-display',
			);
		}
	}
}
